module.exports = __webpack_public_path__ + "static/img/home_img_judian.67d6f81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_img_judian.png
// module id = r5W4
// module chunks = 2